import { html } from "htm/preact";
import { ctx, translate } from "..";




export default function EnvironmentalLabelsComponent() {
    const { dispatch, state } = ctx();
    const selectedLabels = state.labels;

    const handleInputChange = (e: Event) => {
        const inputElem = e.currentTarget as HTMLInputElement
        const selectedLabel = inputElem.id

        dispatch({
            type: 'labels.selected',
            labels: inputElem.checked ? Array.from(new Set([...selectedLabels, selectedLabel])) : selectedLabels.filter(label => label != selectedLabel)
        })
    }


    const filteredProducts = state.allProducts.filter(product => product.labels && product.labels.length > 0);
    const labels = Array.from(new Set(filteredProducts.map(product => product.labels).flat())).filter(l => l);
    return labels.length > 0 && html`
    <div class="environmental-labels" style="margin-top: 2.5em">
        <h6 style="margin-top: 1em; margin-bottom: -.1em;">${translate('Environmental labels')}</h6>
        <form class="input-container" style="margin-top: 1em;">
            ${labels.map(label => html`
            <div style="margin-top: -1em;">
                <input type="checkbox" name=${label} id=${label} class="form-checkbox" style="margin-top: 1em;" onchange=${handleInputChange} checked=${Boolean(selectedLabels.find(selectedLabel => selectedLabel == label))} />
                <label for=${label}>${label}</label>
            </div>
            `)}
        </form>
    </div>`;
}



export function SortimentsFiterComponenet() {
    const { dispatch, state } = ctx();
    const selectedSortiments = state.labels2;

    const handleInputChange = (e: Event) => {
        const inputElem = e.currentTarget as HTMLInputElement
        const selectedSortiment = inputElem.id

        dispatch({
            type: 'labels2.selected',
            labels: inputElem.checked ? Array.from(new Set([...selectedSortiments, selectedSortiment])) : selectedSortiments.filter(sortiment => sortiment != selectedSortiment)
        })
    }


    const filteredProducts = state.allProducts.filter(product => product.labels2 && product.labels2.length > 0);
    const labels = Array.from(new Set(filteredProducts.map(product => product.labels2).flat())).filter(l => l);
    return labels.length > 0 && html`
    <div class="environmental-labels" style="margin-top: 2.5em">
        <h6 style="margin-top: 1em; margin-bottom: -.1em;">${translate('Sortiment')}</h6>
        <form class="input-container" style="margin-top: 1em;">
            ${labels.map(label => html`
            <div style="margin-top: -1em;">
                <input type="checkbox" name=${label} id=${label} class="form-checkbox" style="margin-top: 1em;" onchange=${handleInputChange} checked=${Boolean(selectedSortiments.find(selectedSortiment => selectedSortiment == label))} />
                <label for=${label}>${label}</label>
            </div>
            `)}
        </form>
    </div>`;
}
